import { versions } from "./versions";

export const environment = {
  production: true,
  origin: "https://api.pilot.genalyte.com",
  envName: "pilot",
  versions,
  domain: "portal.pilot.genalyte.com",
  callbackUrl: "https://covid-physicians.pilot.genalyte.com",
  stripeTestKey: "pk_test_2eBUbqDlmia0ycUM1EtBY5mL",
  stripeProdKey: "pk_live_vXqBFKjbZMRwkHEyX73mW6Re",
  prod_sku_product: "sku_H6uSEdvXhkMaWu",
  test_sku_product: "sku_H6feIfIgaqGQiV",
  newFeature: false,
  google_analytics: {
    GOOGLE_ID_PILOT: "UA-145088452-5",
    GOOGLE_ID_QA: "UA-145088452-4",
  },
  bullet_train_environmentID: "89WZRaen3defTmLXQExjdr",
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts